import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {
  take as rxTake,
} from 'rxjs';

import { RetrieveByKey } from '@login/interfaces';
import { LoginService } from '@login/services';

@Component({
    selector: 'kws-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    standalone: false
})
export class LogoComponent implements OnInit {
  @Input() showBack: boolean = false;
  @Output() buttonClicked = new EventEmitter();

  public logoToShow: any = './assets/images/logo.svg';
  public readonly defaultLogo: any = './assets/images/logo.svg';

  constructor(
    private loginService: LoginService,
  ) { }

  ngOnInit(): void {
    this.getCompanyLogo();
  }

  public buttonClick(event: Event) {
    event.preventDefault();
    this.buttonClicked.emit();
  }

  private getCompanyLogo() {
    this.loginService.getCompanyLogo().pipe(rxTake(1))
      .subscribe((response: RetrieveByKey) => {
        // Prefer the Print logo (a colored logo that renders on the white sign-in background),
        // falling back to the Company logo, then to the bundled default. See ANG-15406.
        // The legacy Path fields are only meaningful when UseBlobStorage is false - otherwise
        // a stale value left over from before the company migrated to blob storage would
        // incorrectly take precedence over the real Blob Storage Display URL.
        if (response.UseBlobStorage && response.PrintLogoBlobStoragePathDisplay && response.PrintLogoBlobStoragePathDisplay !== '') {
          this.logoToShow = response.PrintLogoBlobStoragePathDisplay;
        } else if (!response.UseBlobStorage && response.PrintLogoPath && response.PrintLogoPath !== '') {
          this.logoToShow = response.PrintLogoPath;
        } else if (response.UseBlobStorage && response.LogoBlobStoragePathDisplay && response.LogoBlobStoragePathDisplay !== '') {
          this.logoToShow = response.LogoBlobStoragePathDisplay;
        } else if (!response.UseBlobStorage && response.LogoPath && response.LogoPath !== '') {
          this.logoToShow = response.LogoPath;
        } else {
          this.logoToShow = this.defaultLogo;
        }
      });
  }
}
